<template>
  <v-card color="indigo lighten-5" outlined>
    <v-card-text class="py-0">
      <v-row class="pb-2" dense>
        <v-col cols="12">
          <v-autocomplete
            id="lookup-anchor"
            label="Buscar un cliente"
            append-icon="mdi-magnify"
            no-data-text="No hay datos para mostrar..."
            hint="Ctrl + C"
            :value="client"
            :search-input.sync="search"
            :items="search != null && search.length > 0 ? items : noSearchItems"
            @change="updateClient"
            persistent-hint
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            label="Nombre"
            append-icon="mdi-account"
            :value="name"
            @input="updateName"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            label="Teléfono"
            append-icon="mdi-phone"
            :value="phone"
            @input="updatePhone"
            hint="e.g. 5555555555"
            persistent-hint
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            label="Correo"
            append-icon="mdi-email"
            :value="email"
            @input="updateEmail"
            hint="e.g. ejemplo@dominio.com"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { httpGet } from "@/services/apiService";

export default {
  data() {
    return {
      items: [],
      noSearchItems: [],
      search: "",
    };
  },
  computed: {
    name: {
      get() {
        return this.$store.state.client.name;
      },
    },
    email: {
      get() {
        return this.$store.state.client.email;
      },
    },
    phone: {
      get() {
        return this.$store.state.client.phone;
      },
    },
    client: {
      get() {
        return this.$store.state.client.selectedClient;
      },
    },
  },
  methods: {
    async get() {
      const { data } = await httpGet("/clientes?populate=descuentos");

      this.items = [];
      for (const d of data?.data) {
        const item = {
          value: d,
          text: `${d.attributes?.nombre} ${d.attributes?.rfc ?? ""} ${
            d.attributes?.clave ?? ""
          }`,
        };
        this.items.push(item);
      }
      ("Clientes", data?.data);
    },
    updateName(event) {
      this.$store.commit("setName", event);
    },
    updateEmail(event) {
      this.$store.commit("setEmail", event);
    },
    updatePhone(event) {
      this.$store.commit("setPhone", event);
    },
    updateClient(event) {
      this.$store.commit("setSelectedClient", event);

      this.updateName(event?.attributes?.nombre ?? null);
      this.updateEmail(event?.attributes?.correo ?? null);
      this.updatePhone(event?.attributes?.telefono ?? null);

      this.$store.dispatch("getDiscounts");
    },
  },
  created() {
    this.get();
  },
};
</script>